export const links: { id: number; label: string; to: string }[] = [
  { id: 1, label: "Клиенты", to: "/" },
  { id: 2, label: "Поездки", to: "/travel" },
  { id: 3, label: "Автомобили", to: "/vehicles" },
  { id: 6, label: "Марки автомобилей", to: "/vehicle-mark" },
  { id: 7, label: "Типы автомобилей", to: "/vehicle-type" },
  { id: 8, label: "Статусы системы лояльности", to: "/promo-status" },
  { id: 9, label: "Достижения", to: "/achievment" },
  { id: 10, label: "Push-уведомления", to: "/push" },
  { id: 11, label: "Популярные автомобили", to: "/vehicle-popular" },
  { id: 11, label: "Список авто с акциями", to: "/vehicle-stock" },
  { id: 11, label: "Новые авто", to: "/vehicle-new" },
  { id: 12, label: "Цвета автомобилей", to: "/color" },
  { id: 13, label: "Статьи", to: "/article" },
  { id: 15, label: "Категории статей", to: "/article-category" },
  { id: 14, label: "Промоблоки", to: "/promoblock" },
];
